import * as angular from 'angular';
import LineConfigsServiceName, {
  LineConfigsService, LineCounts, LineItem,
  LineJunctionItem
} from "../../services/lineConfigs/lineConfigs.service";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import * as _ from "lodash";
import template from './editLineJunction.tpl.html';

let requires = [LineConfigsServiceName, NewGuidServiceName, LoaderServiceName, NotifyServiceName];

interface EditLineJunction {
  save: () => void;
  close: () => void;
  lineIsSelected: (lineId: string) => boolean;
  toggleInputLine: (line: LineItem) => void;
  dialogHeaderText: string;
  form: angular.IFormController;
  editedLineJunction: LineJunctionItem;
  editedLineConfig: LineCounts;
  eligibleInputs: LineItem[];
}

export interface EditLineJunctionData {
  lineJunction: apsViewModels.LineJunctionItem;
  line: LineItem;
  shop: apsViewModels.ShopNavigation;
  lineConfig: LineCounts;
}

export function openEditLineJunction(data: EditLineJunctionData,
                                     $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditLineJunctionCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.editLineJunction', requires)
  .controller('EditLineJunctionCtrl', editLineJunctionCtrl)
  .name;

function editLineJunctionCtrl(
  newGuidService: NewGuidService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  lineConfigsService: LineConfigsService,
  $modalInstance: mm.foundation.modalInstance,
  data: EditLineJunctionData
) {

  let vm = {} as EditLineJunction;

  vm.dialogHeaderText = 'Add Line Junction';
  vm.editedLineJunction = <any>{};

  if (data.lineJunction) {
    _.assign(vm.editedLineJunction, data.lineJunction);
    vm.dialogHeaderText = 'Edit Line Junction';
  } else {
    newGuidService.getNewGuid('lineJunction').then(id => vm.editedLineJunction.id = id.toString());
    vm.editedLineJunction.shopId = data.shop.id;
    if (!vm.editedLineJunction.inputs) {
      vm.editedLineJunction.inputs = [];
    }
    if (data.line) {
      vm.editedLineJunction.inputs.push(data.line);
    }
  }

  vm.eligibleInputs = _.filter(data.lineConfig.lines, (line: LineItem) => {
    return !line.endJunction;
  });

  vm.lineIsSelected = (lineId: string) => {
    return _.some(vm.editedLineJunction.inputs, {id: lineId});
  };

  vm.toggleInputLine = (line: LineItem) => {
    let lineIsAnInput = _.some(vm.editedLineJunction.inputs, line);
    if (lineIsAnInput) {
      _.remove(vm.editedLineJunction.inputs, line);
    } else {
      vm.editedLineJunction.inputs.push(line);
    }
  };

  vm.save = () => {
    if (vm.form.$invalid) {
      return;
    }

    vm.editedLineJunction.name = vm.editedLineJunction.name.toUpperCase();

    let promise = data.lineJunction
      ? lineConfigsService.updateLineJunction({
          id: vm.editedLineJunction.id,
          isTable: vm.editedLineJunction.isTable,
          name: vm.editedLineJunction.name,
          shopId: data.shop.id
        })
      : lineConfigsService.addLineJunction({
          id: vm.editedLineJunction.id,
          inputLineIds: _.map(vm.editedLineJunction.inputs, 'id'),
          isTable: vm.editedLineJunction.isTable,
          name: vm.editedLineJunction.name,
          shopId: data.shop.id
        });

    loaderService.loadingPromise(promise.then(() => {
      $modalInstance.close(vm.editedLineJunction);
    }, notifyService.handleApiErrors));
  };

  vm.close = () => {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/lineConfigs/editLineJunction.controller.ts